import getAssignee from './getAssignee';
import isRequestSignaturePopup from './isRequestSignaturePopup';
import wasRequestSignaturePopup from './wasRequestSignaturePopup';

export default signerAddress => popup => (
  (isRequestSignaturePopup(popup) || wasRequestSignaturePopup(popup)) && (
    !signerAddress || // signer address will not be defined in some editor modes
    [undefined, signerAddress].includes(getAssignee(popup))
  )
);



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isPopupAssignedToSigner.jsx